
const digest = '0ba0370042d67b6ef3eb290cf17024709b93cf5695434cef961d141dbbf78a62';
const classes = {"wrapper":"_wrapper_d0m9a_1"};
const css = `._wrapper_d0m9a_1 {
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  padding: 3px 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  